import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    Output,
    SimpleChanges,
} from '@angular/core';
import { EducationProgramDTO } from '@core/apis/education/education.dto';
import { RehabilitationProgramDTO } from '@core/apis/rehabilitation/rehabilitation.dto';
import { ServiceDTO } from '@core/apis/service/service.dto';
import { BookingStorageEnum } from '@core/enums/booking.enum';
import {
    IBookingStorageDeleteEvent,
    IImage,
} from '@core/interfaces/booking.interface';
import { FormattedPricePipe } from '@core/pipes/formatted-price.pipe';
import { TranslocoModule } from '@jsverse/transloco';
import { DotSliderComponent } from '../dot-slider/dot-slider.component';
import { ProgramTabsComponent } from '../program-tabs/program-tabs.component';

@Component({
  selector: 'app-product-card',
  imports: [
    TranslocoModule,
    FormattedPricePipe,
    DotSliderComponent,
    CommonModule,
    ProgramTabsComponent,
  ],
  standalone: true,
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardComponent {
  @Input({ required: true }) public program!:
    | EducationProgramDTO
    | RehabilitationProgramDTO
    | ServiceDTO;

  @Input({ required: true }) public teamPath: string = '';
  @Input({ required: true }) public type!: BookingStorageEnum;
  @Output('delete') public delete: EventEmitter<IBookingStorageDeleteEvent> =
    new EventEmitter();

  public images: IImage[] = [];
  public rate: number = Math.round(Math.random() * 100) / 10;

  public filledStars: number = 0;
  public isHalfStar: boolean = false;

  public stars: number[] = [0, 1, 2, 3, 4];

  public discountedPrice: number = 0;
  public discountAmount: number = 0;
  public originalPrice: number = 0;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.updateStarRating(this.rate);
    this.updateImages();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['program']) {
      this.updateImages();
      this.cdr.detectChanges();
    }
  }

  public getDiscountedPrice(price: number, discountPercent = 0): number {
    return price * (1 - discountPercent / 100);
  }

  public calculateDiscountAmount(price: number, discountPercent = 0): number {
    return price * (discountPercent / 100);
  }

  public updateStarRating(rate: number): void {
    this.filledStars = Math.floor(rate / 2);
    this.isHalfStar = rate % 2 >= 0.5;
  }

  private updateImages() {
    this.images =
      this.program.files?.map((file) => ({
        key: file.awsBucketFileKey,
        path: this.teamPath,
      })) ?? [];
  }

  public getDotsCount(): number {
    const imageCount = this.images.length;
    if (imageCount <= 1) {
      return 0;
    }
    return Math.min(imageCount, 5);
  }
}
